import React, {useId, useState} from 'react';
import '../App.css';
import Plus from '../assets/plus'
import Minus from '../assets/minus'

export default function QuestionBox({question, answer}) {
  const [expanded, setExpanded] = useState(false);
  const id = useId();
  return (
    <div className={'faq-item' + (expanded ? ' is-open' : '')}>
      <h3>
        <button type="button" aria-expanded={expanded} aria-controls={id} onClick={() => setExpanded(!expanded)}>
          <span>{question}</span>
          {expanded ? <Minus/> : <Plus/>}
        </button>
      </h3>
      <div id={id} className="faq-answer" hidden={!expanded}>{answer}</div>
    </div>
  )
}
